import React, { useContext } from 'react';
import InputField from '../../../../../components/inputField/InputField';
import { InputText } from 'primereact/inputtext';
import { inputsDadosGerais } from '../../PageInputs';
import styles from './InputNomeIndicador.module.scss';
import { MultipageContext } from '../../../../../core/components/Multipage';

function InputNomeIndicador({ formik, infoMessage, ...rest }) {
    const multipageContext = useContext(MultipageContext);
    const localFormik = formik ?? {
        values: { nmIndicador: multipageContext?.nmIndicador ?? '' },
        errors: {},
        handleChange: () => {},
    };

    let inputs = inputsDadosGerais.filter((input) => input?.name === 'nmIndicador');

    if (!formik) {
        inputs = inputs.map((input) => ({
            ...input,
            form: { use: true, validate: { required: false } },
        }));
    }

    return (
        <InputField
            formController={{
                inputs,
            }}
            formik={localFormik}
            className={styles.nmIndicador}
            id="nmIndicador"
            infoMessage={infoMessage}
            cols="12"
        >
            <InputText
                value={localFormik.values.nmIndicador}
                onChange={localFormik.handleChange}
                {...rest}
            />
        </InputField>
    );
}

export default InputNomeIndicador;
